export const WAREHOUSE_STATUS_ACTIVE = 'active'
export const WAREHOUSE_STATUS_INACTIVE = 'inactive'

export const WAREHOUSE_FILTER_NAME = 'warehouse'
export const AREA_FILTER_NAME = 'area'
export const ZONE_FILTER_NAME = 'zone'
export const LOCATION_FILTER_NAME = 'location'
export const CONTAINER_FILTER_NAME = 'container'
